var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import PBService from "@irati/utils/services";
import client from "@irati/utils/services/apollo";
import getTopUpQuery, { getTopUpKey } from "./queries/getTopUp";
import completeTopupMutation, { completeTopupKey } from "./mutations/completeTopup";
import getTopUpsQuery, { getTopUpsKey } from "./queries/getTopUps";
import createTopUpMutation, { createTopUpKey } from "./mutations/createTopup";
import createTenantWalletTransfers from "./mutations/TenantWalletTransfers";
var TopUpWallet = /** @class */ (function (_super) {
    __extends(TopUpWallet, _super);
    function TopUpWallet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TopUpWallet.prototype.list = function (args, options) {
        if (options === void 0) { options = {}; }
        var variables = __assign({}, args);
        return client.query(__assign(__assign({}, options), { query: getTopUpsQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[getTopUpsKey];
        });
    };
    TopUpWallet.prototype.get = function (topupId, options) {
        if (options === void 0) { options = {}; }
        var variables = { topupId: topupId };
        return client.query(__assign(__assign({}, options), { query: getTopUpQuery, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[getTopUpKey];
        });
    };
    TopUpWallet.prototype.create = function (args, options) {
        if (options === void 0) { options = {}; }
        var variables = __assign({}, args);
        return client.mutate(__assign(__assign({}, options), { mutation: createTopUpMutation, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[createTopUpKey];
        });
    };
    TopUpWallet.prototype.complete = function (topupId, options) {
        if (options === void 0) { options = {}; }
        var variables = { topupId: topupId };
        return client.mutate(__assign(__assign({}, options), { mutation: completeTopupMutation, variables: variables })).then(function (_a) {
            var data = _a.data;
            return data[completeTopupKey];
        });
    };
    TopUpWallet.prototype.createLegacyTenantWalletTransfer = function (data) {
        return client.mutate({ mutation: createTenantWalletTransfers, variables: { data: data } }).then(function () { return true; });
    };
    return TopUpWallet;
}(PBService));
export default new TopUpWallet({ errorHandlers: [] });
